import React from 'react'

import { IconButton } from 'components/shared/IconButton/IconButton'

import styles from './StepButton.module.scss'

type StepButtonProps = Pick<
  React.ComponentProps<typeof IconButton>,
  'ariaLabel' | 'icon' | 'onClick' | 'isDisabled'
>

export const StepButton = ({
  ariaLabel,
  icon,
  onClick,
  isDisabled,
}: StepButtonProps) => (
  <IconButton
    className={styles.button}
    size="medium"
    variant="outlined"
    {...{ ariaLabel, icon, onClick, isDisabled }}
  />
)
